import { useAuth } from '@services/auth/useAuth'
import { CompanyStatusEnumMap, useGetCompanies } from '@services/companies'
import { Select, SelectProps } from '@shared/Form/Select'
import useUserOrgSession from '@shared/innmaxLib/hooks/useUserOrgSession'
import { Space } from 'antd'
import { isNil } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function CompaniesSelect({
  status,
  onChange,
  value,
  ...props
}: SelectProps & {
  status?: keyof typeof CompanyStatusEnumMap
}) {
  const { dataSource, byId } = useGetCompanies()

  const { t } = useTranslation()

  const { user } = useAuth()

  const { orgSession, isCompleted } = useUserOrgSession()

  const [parentId, setParentId] = React.useState<number | undefined>(undefined)
  const [subId, setSubId] = React.useState<number | undefined>(undefined)
  const [subSessions, setSubSessions] = React.useState<any[]>([])

  const handleChange: SelectProps['onChange'] = (value, option) => {
    // click clear
    if (value === undefined) {
      onChange?.(value, option)
      setParentId(undefined)
      setSubId(undefined)
      setSubSessions([])
      return
    }
    const selected = dataSource?.content.find(x => x.id === value)
    setSubSessions(selected?.sessions || [])
    if (selected?.sessions?.length) {
      setParentId(value as number)
      setSubId(undefined)
      onChange?.(undefined, [])
      return
    }
    onChange?.(value, option)
  }

  const handleSubChange: SelectProps['onChange'] = (value, option) => {
    setSubId(value as number)
    if (onChange) {
      onChange(value, option)
    }
  }

  React.useEffect(() => {
    if (!byId) {
      return
    }
    const company = byId[value as number]
    if (!company) {
      return
    }

    if (company?.stackIndex === 1) {
      setParentId(company.parentSessionId)
      setSubId(company.id)
    } else {
      setParentId(value as number)
    }
    const parent = byId[company.parentSessionId]
    setSubSessions(parent?.sessions || [])
  }, [value, byId])

  if (isCompleted && orgSession && user?.role === 'APCompany') {
    onChange?.(orgSession.id, [])
    return (
      <Select
        allowClear
        placeholder={'地勤公司名稱'}
        value={orgSession.id}
        {...props}>
        <Select.Option key={orgSession.id} value={orgSession.id}>
          {orgSession.name}
        </Select.Option>
      </Select>
    )
  }

  return (
    <Space>
      <Select
        allowClear
        placeholder={'地勤公司名稱'}
        value={parentId}
        {...props}
        onChange={handleChange}>
        {dataSource?.content
          ?.filter(x => (!isNil(status) ? x.status === status : true))
          .map(x => (
            <Select.Option key={x.id} value={x.id}>
              {x.name}
            </Select.Option>
          ))}
      </Select>
      {subSessions?.length > 0 && (
        <Select
          allowClear
          placeholder={'子單位名稱'}
          style={{ minWidth: 120 }}
          value={subId}
          onChange={handleSubChange}>
          {subSessions
            ?.filter(x => (!isNil(status) ? x.status === status : true))
            .map(x => (
              <Select.Option key={x.id} value={x.id}>
                {x.name}
              </Select.Option>
            ))}
        </Select>
      )}
    </Space>
  )
}
